module.exports = __webpack_public_path__ + "core-fonts/maxpro_s-demibold-webfont.374ce42ffead64edd7de35bcc39843ac.woff";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/font/maxpro_s-demibold-webfont.woff
// module id = 15
// module chunks = 0